export const TOP_POSITION = 200
export const DELAY_TIME = 400
